const P = {
  systemAlert: 'SYSTEM',
  notification: 'NOTIFICATION',
  scheduled: 'SCHEDULED',
};

export { P as notifyP };
